// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3u2xf","insightsList":"newBusinessInsightsMenu_insightsList__2APFx","active":"newBusinessInsightsMenu_active__MTp4f"};